module.exports = __webpack_public_path__ + "assets/img/station3.40e0706a.png";